module.exports = __webpack_public_path__ + "media/images/es/hero-bg-58eadb2008018c560e5fea2fa0a64496.jpg";